module.exports = __webpack_public_path__ + "img/payment-details-icon.72c65f18.svg";